<template>
  <header class="page-header" :class="{ '-accent': accent }">
    <BranchShape
      v-scroll:reveal="{ delay: 75 }"
      class="layout-cta__branch"
      color="white"
      :opacity="shapeOpacity"
      header
    />

    <section class="page-header__container">
      <BreadCrumbs />

      <h1 v-scroll:reveal="{ delay: 50 }" class="page-header__banner">{{ title }}</h1>
    </section>
  </header>
</template>

<script>
export default {
  name: 'NavigationHeader',
  props: {
    title: String,
    accent: Boolean
  },
  computed: {
    shapeOpacity() {
      return this.accent ? 0.1 : 0.4
    }
  }
}
</script>
